module.exports = __webpack_public_path__ + "static/media/twit.a4e34ad9.svg";